import router from '..'
import { useAppBootstrap } from '@/composables/useAppBootstrap/useAppBootstrap'
import operatorAuthGuard from './operatorAuthGuard'
import { lastVisitedRouteGuard } from './lastVisitedRouteGuard'
import { settingsUnsavedChangesGuard } from './settingsUnsavedChangesGuard'

export const registerGuards = () => {
  // Block all subsequent guards until bootstrap finishes (init stuff defined in startApp)
  router.beforeEach(async () => {
    const { waitForAppReady } = useAppBootstrap()
    await waitForAppReady()
  })

  operatorAuthGuard()
  lastVisitedRouteGuard()
  settingsUnsavedChangesGuard()
}
